import Vue from 'vue';
import Vuex from 'vuex';
import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';

// Modules
import common from './modules/common.js';
import header from './modules/header';
import pages from './modules/pages';
import templates from './modules/templates';
import regions from './modules/regions';
import modules from './modules/modules';
import results from './modules/results';
import properties from './modules/properties';
import lists from './modules/lists';
import applinks from './modules/applinks';
import slideshows from './modules/slideshows';
import filterbar from './modules/filterbar';
import users from './modules/users';
import bookings from './modules/bookings';
import countries from './modules/countries';
import cardpaymentresponse from './modules/cardpaymentresponse';
import experiences from './modules/experiences';
import clientmanagers from './modules/clientmanagers';
import guestlogins from './modules/guestlogins';
import presspages from './modules/presspages';
import passportdetails from './modules/passportdetails';
import wineorders from './modules/wineorders';
import contacts from './modules/contacts';
import enquiries from './modules/enquiries';
import currencies from './modules/currencies';
import regionplaces from './modules/regionplaces';
import googledatalayerhelper from './modules/googledatalayerhelper';
import feedback from './modules/feedback';
import bookingconditions from './modules/bookingconditions';
import FAQ from './modules/FAQ';
import Weather from './modules/Weather';
import Carhire from './modules/Carhire';
import sharedshortlists from './modules/sharedshortlists';
import blogs from './modules/blogs';
import algolia from './modules/algolia';
import guests from './modules/guests';
import trustpilot from './modules/trustpilot';
import villaviews from './modules/villaviews';
import cosignins from './modules/cosignins';
import transfers from './modules/transfers';
import transportation from './modules/transportation.js';
import sca from './modules/sca';
import planner from './modules/planner';
import poi from './modules/poi';
import checkout from './modules/Checkout';
import searchvilla from './modules/searchvilla';
import villabook from './modules/villabook';

const logrocketPlugin = createPlugin(LogRocket);

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common,
    header,
    pages,
    regions,
    templates,
    modules,
    results,
    properties,
    lists,
    applinks,
    slideshows,
    filterbar,
    users,
    bookings,
    countries,
    cardpaymentresponse,
    experiences,
    clientmanagers,
    guestlogins,
    presspages,
    passportdetails,
    wineorders,
    enquiries,
    contacts,
    currencies,
    regionplaces,
    googledatalayerhelper,
    feedback,
    bookingconditions,
    FAQ,
    Weather,
    Carhire,
    sharedshortlists,
    blogs,
    guests,
    algolia,
    trustpilot,
    villaviews,
    cosignins,
    transfers,
    transportation,
    sca,
    planner,
    poi,
    plugins: [logrocketPlugin],
    checkout,
    searchvilla,
    villabook,
  },
});
